import { render, staticRenderFns } from "./packageTable2.vue?vue&type=template&id=0e28c655&scoped=true&"
import script from "./packageTable2.vue?vue&type=script&lang=js&"
export * from "./packageTable2.vue?vue&type=script&lang=js&"
import style0 from "./packageTable2.vue?vue&type=style&index=0&id=0e28c655&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e28c655",
  null
  
)

component.options.__file = "packageTable2.vue"
export default component.exports